import { createSelector, createSlice } from '@reduxjs/toolkit';
import uuid from 'uuid/v4';

const STATE_PREFIX = 'notifications';

const initialState = {
    notifications: [],
};

const notifications = createSlice({
    name: STATE_PREFIX,
    initialState,
    reducers: {
        setNotifications(state, { payload: notifications }) {
            state.notifications = notifications;
        },
        showNotification(
            state,
            { payload: { messageId, values = {}, severity = 'success' } },
        ) {
            state.notifications = [
                ...state.notifications,
                {
                    notificationId: uuid(),
                    open: true,
                    focused: false,
                    messageId,
                    values,
                    severity,
                    lastInteractionAt: new Date().getTime(),
                },
            ];
        },
        focusIn(state, { payload: notificationId }) {
            state.notifications = state.notifications.map(n =>
                n.notificationId === notificationId
                    ? {
                          ...n,
                          open: true,
                          lastInteractionAt: new Date().getTime(),
                          focused: true,
                      }
                    : n,
            );
        },
        focusOut(state, { payload: notificationId }) {
            state.notifications = state.notifications.map(n =>
                n.notificationId === notificationId
                    ? {
                          ...n,
                          open: true,
                          lastInteractionAt: new Date().getTime(),
                          focused: false,
                      }
                    : n,
            );
        },
        closeNotification(state, { payload: notificationId }) {
            state.notifications = state.notifications.map(n => ({
                ...n,
                open: n.notificationId === notificationId ? false : n.open,
            }));
        },
    },
});

export const {
    focusIn,
    focusOut,
    showNotification,
    closeNotification,
    setNotifications,
} = notifications.actions;

export const notificationsSelector = state => state[STATE_PREFIX];

export const selectNotifications = createSelector(
    notificationsSelector,
    notificationsSlice => notificationsSlice.notifications,
);

export const selectVisibleNotifications = createSelector(
    selectNotifications,
    notifications => notifications.filter(n => n.open),
);

export default notifications.reducer;
